import { useDocumentStore } from "../store/document";

export function clientUpdateRequested() {
  const documentStore = useDocumentStore();
  documentStore.clientUpdateRequested = true;
}
